import { HasId, ID } from "src/libs/interfaces/layouts"
import { defaultPosition, HISTORY_TYPE, IHistoryStep, ILandingSection, LANDING_EDIT_MODE, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import CarouselCardWidget from "../landing-edit/CarouselCardWidget"
import CarouselWidget from "../landing-edit/CarouselWidget"
import ColumnCardWidget from "../landing-edit/ColumnCardWidget"
import ColumnWidget from "../landing-edit/ColumnWidget"
import CompositionCardWidget from "../landing-edit/CompositionCardWidget"
import CompositionWidget from "../landing-edit/CompositionWidget"
import { ICurrentEditType } from "../landing-edit/landing-edit-modal"
import updateHistory from "../landing-edit/utils/updateHistory"
import TabsWidget from "../landing-edit/TabsWidget"
import ColumnsProportiaWidget from "src/modules/pe-landing-module/widgets/ColumnsProportiaWidget"

export default function contextMethods (): any {
    return {
        changeSection : (sectionId: ID, sectionEditTab: string = "main") => {   
            const section = useLandingStore.getState().currentLanding.sections.find((section: HasId) => section.id === sectionId) 
            useLandingStore.setState({ 
                curEditModal: { 
                    ...section[ sectionEditTab ], 
                    sectionId, 
                    currentEditType: sectionEditTab,
                } as ICurrentEditType
            })  
        },
        deleteSection: (id: ID) => {    
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find((section: HasId) => section.id === id) 
            const historyStep: IHistoryStep = {
                data:  null,
                prevData: section,
                type: HISTORY_TYPE.SECTION,
                title : "Remove section",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.filter((sec: HasId) => sec.id !== section.id )
            }  
            updateHistory( historyStep, newLanding )           
        },
        deleteTitle: (id: ID) => { 
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find( (section: HasId) => section.id === id )
            const prevData          = JSON.parse( JSON.stringify( section ) )
            const newSection: any   = { ...section, title: {}, description: {} } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Remove section's Title",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.map((sec: HasId) => {
                    if(sec.id === id ) {
                        return newSection
                    }
                    return sec
                })
            }  
            updateHistory( historyStep, newLanding )  
        },
        changeTitleSection: (sectionId: ID) => { 
            const section: ILandingSection = useLandingStore.getState().currentLanding.sections.find( ( section: ILandingSection ) => section.id === sectionId )
            
            console.log( section.title )
            
            useLandingStore.setState({ 
                curEditModal: { 
                    ...section.title, 
                    sectionId, 
                    currentEditType: SELECT_TYPE.TITLE
                } as ICurrentEditType
            })  
        },
        changeDescriptionSection: (sectionId: ID) => { 
            const section: ILandingSection = useLandingStore.getState().currentLanding.sections.find( ( section: ILandingSection ) => section.id === sectionId )            
            console.log( section.description )
            
            useLandingStore.setState({ 
                curEditModal: { 
                    ...section.description, 
                    sectionId, 
                    currentEditType: SELECT_TYPE.DESCRIPTION
                } as ICurrentEditType
            })  
        },
        changeMeat: (meatId: ID, sectionId: ID) => { 
            const section: ILandingSection = useLandingStore.getState().currentLanding.sections.find( ( section: ILandingSection ) => section.id === sectionId ) 
            const meat  = section.data.find(meat => meat.id === meatId)
            useLandingStore.setState({ 
                curEditModal: { 
                    ...meat, 
                    sectionId, 
                    currentEditType: SELECT_TYPE.CONTENT 
                } as ICurrentEditType
            })  
        },
        deleteMeat: (meatId: ID, sectionId: ID) => { 
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )
            const prevData          = JSON.parse( JSON.stringify( section ) )
            const newSection: any   = { 
                ...section, 
                data: section.data.filter((meat: HasId) => meat.id !== meatId)
            } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Remove Meat",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.map((sec: HasId) => {
                    if(sec.id === sectionId ) {
                        return newSection
                    }
                    return sec
                })
            }  
            updateHistory( historyStep, newLanding )  
        },
        transformMeat: (meatId: ID, sectionId: ID) => { 
            useLandingConsoleStore.setState({ 
                editMode: LANDING_EDIT_MODE.TRANSFORM,
            })
            useLandingStore.setState({
                selectedMeat: meatId, 
                selectedFloat: "", 
                selectedLayer: sectionId,
                selectedType: SELECT_TYPE.CONTENT,
            })
            //alert("Transform Meat:" + meatId + "," + sectionId)
        },
        resetTransformMeat: (meatId: ID, sectionId: ID) => { 
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )
            const prevData          = JSON.parse( JSON.stringify( section ) )
            const newSection: any   = { 
                ...section, 
                data: section.data.filter((meat: HasId) => meat.id !== meatId)
            } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Reset transform Meat",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.map((sec: ILandingSection) => {
                    if(sec.id === sectionId ) {
                        return {
                            ...sec,
                            data: sec.data.map( meat => {
                                if( meat.id === meatId ) {
                                    return {
                                        ...meat,
                                        position: defaultPosition()
                                    }
                                }
                                return meat
                            })
                        }
                    }
                    return sec
                })
            }  
            updateHistory( historyStep, newLanding ) 
        },
        addMeat: (sectionId: ID, meatId: ID) => {  
            useLandingStore.setState({ 
                isAddMeatDrawerOpen: true, 
                addMeatDrawerSectionId: sectionId,
                addMeatDrawerMeatId: meatId
            }) 
        },
        editFloat: (floatId: ID, sectionId: ID) => { 
            const section: ILandingSection = useLandingStore.getState().currentLanding.sections.find( ( section: ILandingSection ) => section.id === sectionId ) 
            const float  = section.floats.find(fl => fl.id === floatId)
            useLandingStore.setState({ 
                curEditModal: { 
                    ...float, 
                    sectionId, 
                    currentEditType: SELECT_TYPE.FLOAT 
                } as ICurrentEditType
            })  
        },
        deleteFloat: (floatId: ID, sectionId: ID) => { 
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )
            const prevData          = JSON.parse( JSON.stringify( section ) )
            const newSection: any   = { 
                ...section, 
                floats: section.floats.filter((float: HasId) => float.id !== floatId)
            } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Remove Float",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.map((sec: HasId) => {
                    if(sec.id === sectionId ) {
                        return newSection
                    }
                    return sec
                })
            }  
            updateHistory( historyStep, newLanding )  
        },
        resetTransformFloat: (meatId: ID, sectionId: ID) => { 
            const currentLanding    = useLandingStore.getState().currentLanding
            const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )
            const prevData          = JSON.parse( JSON.stringify( section ) )
            const newSection: any   = { 
                ...section, 
                floats: section.floats.filter((float: HasId) => float.id !== meatId)
            } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Reset transform Float",
            }
            const newLanding = {
                ...currentLanding,
                sections: currentLanding.sections.map((sec: ILandingSection) => {
                    if(sec.id === sectionId ) {
                        return {
                            ...sec,
                            floats: sec.floats.map( float => {
                                if( float.id === meatId ) {
                                    return {
                                        ...float,
                                        position: {
                                            ...float.position,
                                            rotate: 0
                                        }
                                    }
                                }
                                return float
                            })
                        }
                    }
                    return sec
                })
            }  
            updateHistory( historyStep, newLanding ) 
        },
        compositionWidget: ( sectionId : ID ) => { 
            return <CompositionWidget sectionId={sectionId} />
        },
        columnWidget: ( sectionId : ID ) => { 
            return <ColumnWidget sectionId={sectionId} />
        }, 
        carouselWidget: ( sectionId : ID ) => { 
            return <CarouselWidget sectionId={sectionId} />
        },
        tabsWidget: ( sectionId : ID ) => { 
            return <TabsWidget sectionId={sectionId} />
        },
        compositionCardWidget: ( sectionId : ID, dataId: ID, id: ID ) => { 
            return <CompositionCardWidget sectionId={sectionId} dataId={dataId} id={id} />
        },
        columnCardWidget: ( sectionId : ID, dataId: ID, id: ID ) => { 
            return <ColumnCardWidget sectionId={sectionId} dataId={dataId} id={id} />
        },
        carouselCardWidget: ( sectionId : ID, dataId: ID, id: ID ) => { 
            return <CarouselCardWidget sectionId={sectionId} dataId={dataId} id={id} />
        }, 
    }
}